import { IconLock } from '@smartbear/swagger-portal-component-library'
import { clsx } from 'clsx'
import { useTranslation } from 'react-i18next'

export const ProductVisibility = ({ isPreview }: { isPreview?: boolean, accentColor?: string }) => {
  const { t } = useTranslation()

  return (
    <div
      aria-label={t('portal.landingPage.productTile.requestAccess.productVisibility.ariaLabel')}
      className={clsx(
        'w-8 h-8 flex items-center justify-center rounded pointer-events-auto border-1.5',
        'text-(--sp-product-tile-lock-icon-color,var(--neutral-80)) dark:text-(--sp-product-tile-lock-icon-color,var(--neutral-50)) bg-(--sp-color-surface-hover) border-(--sp-color-border)',
        !isPreview && 'hover:bg-(--sp-color-surface-inverse) hover:text-(--sp-color-text-inverse) dark:hover:text-(--sp-color-text-inverse) hover:border-none',
        'border-(--sp-color-accent) dark:border-(--sp-color-accent)'
      )}
    >
      <IconLock />
    </div>
  )
}